import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

const Language = styled.div`
  color: ${props => (props.isActive ? props.theme.color.primary : props.theme.color.label)};
  font-weight: ${props => (props.isActive ? 500 : 'normal')};
  display: inline-block;
  padding: 11px 9px;
  cursor: pointer;
`;

const LanguageLine = styled.div`
  display: inline;
  border-left: 1px solid ${props => props.theme.color.border};
`;

const langSwitcher = props => {
  const { i18n } = props;
  return (
    <div>
      <Language
        isActive={i18n.language === 'en'}
        onClick={() => {
          i18n.changeLanguage('en');
        }}
      >
        EN
      </Language>

      <LanguageLine />

      <Language
        isActive={i18n.language === 'nl'}
        onClick={() => {
          i18n.changeLanguage('nl');
        }}
      >
        NL
      </Language>
    </div>
  );
};

export default translate()(langSwitcher);
